import {isObject, each, isNumber, isString, isArray, isDate, maxBy} from "lodash";

export function capitalizeFirstLetter(string) {
    return string[0].toUpperCase() + string.slice(1);
}

export function unCapitalizeFirstLetter(string) {
    return string[0].toLowerCase() + string.slice(1);
}

// NOTE if not a number assumes TZ is part of parsable string
export function getDate(timestamp) {
    var date = new Date(timestamp);
    //if (isNumber(timestamp))
    //    date.setUTCDate(2);
    return date;
}

// converts keys name *Date  and  arrays *Dates
export function convertDatesDeep(record)
{
    if (isArray(record)){
        record.forEach(convertDatesDeep);
    } else if (isObject(record)) {
        each(record, function (value, key) {
            if (isString(key) && key.endsWith('Date') && (isNumber(value) || isString(value))) {
                record[key] = getDate(value);
            } else if (isString(key) && key.endsWith('Dates') && isArray(value)) {
                each(value, function (arrValue, index) {
                    if (isNumber(arrValue) || isString(arrValue)) {
                        value[index] = getDate(arrValue);
                    }
                });
            } else {
                convertDatesDeep(value);
            }
        });
    }
}




// Switch back to time stamps
// TBD UTC vs local issues
// could use lodash cloneDeepWith & isDate ...
// Note This doesn't revert all dates - must follow name convention
export function revertDatesDeep(record)
{
    if (isArray(record)){
        record.forEach(revertDatesDeep);
    } else if (isObject(record)) {
        each(record, function (value, key) {
            if (isString(key) && key.endsWith('Date') && isDate(value) ) {
                record[key] = value.getTime();
            } else if (isString(key) && key.endsWith('Dates') && isArray(value)) {
                each(value, function (arrValue, index) {
                    if (isDate(arrValue)) {
                        value[index] = arrValue.getTime();
                    }
                });
            } else {
                revertDatesDeep(value);
            }
        });
    }
}


//todo FUDGE to select logo as last uploaded Name_ARTWORK
export async function findAdvertiserLogo(advertiser, aodService)
{
    const mfItem = aodService.itemCalls['managedFile'];
    const {managedFiles} = await mfItem.search(advertiser.id, 'advertiser', {
        fileClass: 'INPUT',
        fileType: 'NAME_ARTWORK',
        fileAspect: 'ORIGINAL'
    });
    return maxBy(managedFiles, m=>m.id);
}

export function getQueryString(params,append=false){
    if (!isObject(params)) return '';
    return (append ? '&' : '') + Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
    }).join('&');
}
